import { LuCkEditorToolBar } from '../../lu-ckeditor.models';

export const forumsToolbar: LuCkEditorToolBar[] = [
	{
		name: 'clipboard',
		items: ['Undo', 'Redo']
	},
	{
		name: 'styles',
		items: ['Format']
	},
	{
		name: 'basicstyles',
		items: ['Bold', 'Italic', 'Underline', '-', 'Link', 'Unlink', '-', 'Subscript', 'Superscript']
	},
	{
		name: 'paragraph',
		items: [
			'NumberedList',
			'BulletedList',
			'-',
			'Blockquote',
			'-',
			'JustifyLeft',
			'JustifyCenter',
			'JustifyRight',
			'-',
			'MediaEmbed'
		]
	},
	{
		name: 'insert',
		items: ['djimage']
	}
];
